// src/hooks/useClients.js
import { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import {
  collection,
  getDocs,
  setDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

export function useClients(initialClientId = "") {
  const [clientId, setClientId] = useState(initialClientId);
  const [clientList, setClientList] = useState([]);

  // Load clients once
  useEffect(() => {
    async function loadClients() {
      try {
        const snap = await getDocs(collection(db, "clients"));

        const names = snap.docs.map((d) => ({
          id: d.id,
          name: d.data().name,
        }));

        // ⭐ Insert ALL CLIENTS at the top
        const allOption = { id: "all_clients", name: "ALL CLIENTS" };

        setClientList([allOption, ...names]);
      } catch (err) {
        console.error("Error loading clients:", err);
      }
    }

    loadClients();
  }, []);

  // Same behavior as your old handleClientSelect
  const handleClientSelect = async (eOrValue) => {
    const value =
      typeof eOrValue === "string" ? eOrValue : eOrValue.target.value;

    if (value === "add_new") {
      const newClient = prompt("Enter new client name:");
      if (newClient) {
        const id = newClient.toLowerCase().replace(/ /g, "_");

        await setDoc(doc(db, "clients", id), {
          name: newClient,
          createdAt: serverTimestamp(),
        });

        // Add new client to the list (after ALL CLIENTS)
        setClientList((prev) => [
          prev[0], // keep ALL CLIENTS on top
          ...prev.slice(1),
          { id, name: newClient },
        ]);

        setClientId(id);
      }
    } else {
      setClientId(value);
    }
  };

  return { clientId, setClientId, clientList, handleClientSelect };
}
